// Engravings is a global container for all new stuff about engraving (since introduction of Kombo)
// Engravings.Kombo is used for kombo1 and kombo2 type of engravings
Engravings = {}

// Ids for engraving types
// These strings get to the server
const SHORT_CAP = 'engraving_short_cap'
const SHORT_BODY = 'engraving_short_body'
const LONG_BODY = 'engraving_long_body'
const INLINE_BODY = 'engraving_inline_body'

// These are collected from resources html
const ALL_ENGRAVING_TYPES = []

// The IDs are added to this list automatically when the form builds
var ENGRAVING_PRODUCT_IDS = []

// All products that have engraving enabled get registered here.
// This is used to map more easily.
var ENABLED_ENGRAVINGS = {}

// All forms are registered here
Engravings.AllEngravingForms = []

const SUPPORTED_EMOJIS = {'♥': 'Heart','⌣': 'Smile','☆': 'Star','☉': 'Flower','☋': 'Hearts','☌': 'Sun'}
var FONTS_WITHOUT_EMOJIS = ["Winter Edition"];

// Double quote " is not allowed!
var REGEX_NEW = /^[ŠšÝýÞþŽž¦−×ł!\*,-./0123456789:;<=>\?@ABCDEFGHIJKLMOPQRSTUVWXYZ\[\\\]\^_`#$%&'()\ abcdefghjklmnopqrstuvwxyz\{\|\}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠Ø¥ø¿¡«»…ÀÃÕ–—“”‘’÷ÿŸ⁄€‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇðĄąŚŤŹśťźŻĽľżŔĂĹĆČĘĚĎĐŃŇŐŘŮŰŢţűůřőňńđďěęčćĺăŕŖŗĮįĀāāĒĖėĢģĶķĪīĻļŅņŌōųŲŪūİĞğƯưƠơ¤ŞşȘșȚțªºiNÐŁ☆♥⌣☍☌☋☊☉☈☇]*$/
// var REGEX_NEW_UNSUPPORTED = /[^ŠšÝýÞþŽž¦−×ł!\*\"\*,-./0123456789:;<=>\?@ABCDEFGHIJKLMOPQRSTUVWXYZ\[\\\]\^_`#$%&'()\ abcdefghjklmnopqrstuvwxyz\{\|\}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠Ø¥ø¿¡«»…ÀÃÕ–—“”‘’÷ÿŸ⁄€‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇðĄąŚŤŹśťźŻĽľżŔĂĹĆČĘĚĎĐŃŇŐŘŮŰŢţűůřőňńđďěęčćĺăŕŖŗĮįĀāāĒĖėĢģĶķĪīĻļŅņŌōųŲŪūİĞğƯưƠơ¤ŞşȘșȚțªºiNÐŁ☆♥⌣☍☌☋☊☉☈☇]/g

/* 
  JQUERY ADDITIONAL FUNCTION 
*/

$(document).ready(function(){
  jQuery.fn.extend({
    setCursorPosition: function(pos) {
      this.each(function(index, elem) {
        if (elem.setSelectionRange) {
          elem.setSelectionRange(pos, pos);
        } else if (elem.createTextRange) {
          var range = elem.createTextRange();
          range.collapse(true);
          range.moveEnd('character', pos);
          range.moveStart('character', pos);
          range.select();
        }
      });
      return this;
    },
    getCursorPosition: function() {
        var input = this.get(0);
        if (!input) return; // No (input) element found
        if ('selectionStart' in input) {
            // Standard-compliant browsers
            return input.selectionStart;
        } else if (document.selection) {
            // IE
            input.focus();
            var sel = document.selection.createRange();
            var selLen = document.selection.createRange().text.length;
            sel.moveStart('character', -input.value.length);
            return sel.text.length - selLen;
        }
    }
  });
});




// Remove emojis from text (for fonts like Poppins)
Engravings.clearEmojis = function(userText, $input) {
  return userText.replaceAll(/[⌣☆☇☈☉☊☋☌☍♥]/gi, "")
  
  var userText = $input.val();
  if (userText) { $input.val(userText.replaceAll(/[⌣☆☇☈☉☊☋☌☍♥]/gi, ""));}
}

// Removes unsupported emojis from text. Saves invalid emojis to "unsupportedEmojis".
// const emojiRegex = /\p{Extended_Pictographic}/ug   // This doesn't catch all emojis...
Engravings.removeUnsupportedEmojis = function(userText) {
  userText = userText == null ? '' : String(userText)

  let result = { newText: '', unsupportedEmojis: '' }

  for (let char of userText)
    REGEX_NEW.test(char) ? result.newText += char : result.unsupportedEmojis += char
  
  return result
}

Engravings.addEmojisHtml = function($destination) {

  let html = ['<div class="engraving-characters-container">']

  for (let [emoji, title] of Object.entries(SUPPORTED_EMOJIS))
    html.push('<div class="engraving-characters-absolute engraving-'+title.toLowerCase()+'"><span title="'+title+'" class="engraving-character engraving-character-'+title.toLowerCase()+'">'+emoji+'</span></div>')
  
  html.push('</div>')

  $destination.html(html.join('\n'))
}

// Add <input> properties to <form> so they get collected when submitted
// This will be reduced when we'll be able to remove engraving data from parent product.
Engravings.addEngravingPropertiesToProductForm = function() {

  // Delete all properties
  let $destination = $('#engraving-properties').empty()

  // Leave empty if engraving not available
  if (Engravings.AllEngravingForms.length == 0) return

  // Collect data from Engraving form.
  // And prepare <input> tags.
  let firstForm = Engravings.AllEngravingForms[0]
  let properties = firstForm.collect()  // Collect data from visible view
  let readableTitle = $('#translation_engraving_text').text()
  let _engraving_data = []
  let _engraving_text, _engraving_text_formatted

  if (!$.isEmptyObject(properties)) { // Fields in _engraving_data must be in this order!
    _engraving_data.push(properties['properties[_engraving_font]'])
    _engraving_data.push(properties['properties[_engraving_type]'])
    _engraving_data.push(firstForm.getVisibleView().getProductIdent())
    _engraving_data.push(firstForm.getVisibleView().handle)
    _engraving_text = properties['properties[_engraving_text]']
    _engraving_text_formatted = properties['properties[_engraving_text_formatted]'] || null
    _engraving_data.push('txt=' + (_engraving_text_formatted || _engraving_text)) 
    let html = [`<input type="hidden" name="properties[${readableTitle}]" value="${_engraving_text}">`]
    html.push(`<input type="hidden" name="properties[_engraving_data]" value="${_engraving_data.join('&')}">`)
    $destination.html(html.join('\n'))
  }

}

// Builds the ENABLED_ENGRAVINGS object.
// Extracts all tags from the html and builds a map of all products and their engravings.
// eg: {'cup-matcha': [SHORT_BODY, LONG_BODY], 'timeless-matcha': [SHORT_CAP, LONG_BODY] ...}
Engravings.registerEngravings = function() {
  $('#engraving-form-resources [data-engravingtype]').each(function() {
    ALL_ENGRAVING_TYPES.push($(this).attr('data-engravingtype'))
  })

  ALL_ENGRAVING_TYPES.forEach((type) => {
    $('#engraving-form-resources [data-engravingtype=' + type + '] input').each(function() {
      const tag = $(this).data('tag')
      ENABLED_ENGRAVINGS[tag] = ( ENABLED_ENGRAVINGS[tag] || new Set() ).add(type)
    })
  })
}

// Autodetect tags used for engravings (more than 1 tag for bundles)
Engravings.productTags = function() {
  return g_product.tags.filter(tag => ENABLED_ENGRAVINGS[tag])
}

// Refresh all engraving forms on page
Engravings.refreshAll = function() {
  console.log(Engravings.AllEngravingForms)
  Engravings.AllEngravingForms.forEach(form => form.refresh())
}

// Collect inputs from resources
Engravings.collectAllEngravingProductIds = function() {
  $('#engraving-prices input').each(function() {
    let id = parseInt($(this).attr('data-id'))
    ENGRAVING_PRODUCT_IDS.push(id)
  })
}

// This function tries to guess what product was just added to the cart
// Danger: If this function fails, engraving is not added to the cart
// FUCK YOU SHOPIFY
Engravings.getMostRecentProductFromCart = function(addedProduct) {
  let product = null
  CartManager.lastCart.items.forEach(item => {
    let idOK = addedProduct.id == item.id
    let dataOK = addedProduct.engraving_data == item.properties_all?._engraving_data || null
    if (idOK && dataOK) product = item
  })
  return product
}

/*
____________________________
 
  @CartManager
____________________________
 
  Operations on cart.
  Mixed with Engravings. //fix
 
*/

CartManager = {}

CartManager.listAllEngravings = function() {
  CartManager.lastCart.items.filter(item => item.sku == 'GRAVURA').forEach(item => console.log(item.properties_all))
}

CartManager.saveCartOnLoad = function(cart) {
  Engravings.allItemsInCart = []
  
  // For some reason properties starting with _ get deleted from cart somewhere in the process.
  // For example: "_parent_key" gets lost.
  // So let's make a deep copy of the "properties" object for later use
  for (let item of cart.items) {
    
    // add key to properties for debugging purposes
    if (!CartManager.isEngravingId(item.id))
      $.extend(item.properties, {'_key': item.key})
    
    item.properties_all = JSON.parse(JSON.stringify(item.properties)) || {}

    // Also save the item - we'll need it in case we want to add engraving to the cart
    Engravings.allItemsInCart.push(item)
  }

  CartManager.lastCart = {...cart}
  $('body').trigger('lastCartUpdated')
}

CartManager.fixCart = function(cart) {
  cart = CartManager.propertiesToHtml(cart)       // Build properties HTML for the Drawer
  cart.items = CartManager.addEngravingPriceToProduct(cart.items)
  return cart
}

CartManager.isKeyInCart = function(key) {
  let list = CartManager.lastCart.items.filter(item => item.key == key)
  return list.length > 0
}

// Not in use? //fix
CartManager.removeEngravings = function(items) {
  return items.filter(item => !CartManager.isItemEngraving(item))
}

// Make HTML out of properties
// eg: Engraving: "Text" -> <div>Engraving: Text</div>
CartManager.propertiesToHtml = function(cart) {

  let keyMap = {}
  let translation = $('#translation_engraving_text').text()

  for (let i=0; i<=10; i++) {
    let index = i == 0 ? '' : ' ' + i
    keyMap[translation + index] = '_engraving_font' + index.replace(' ', '')
  }
  
  cart.items.forEach(item => {
    item.properties_formatted = ''

    for (let key in item.properties || {}) {
      if (key.charAt(0) == '_') continue
      
      let val = item.properties[key]

      // If this is engraving text, display it in correct font
      if (!item.properties['_engraving_font'] && item.properties['_engraving_data']) {
        let font = Engravings.findCurrentFontFamily(item.properties['_engraving_data'].split('&')[0])
        val = keyMap[key] ? `<span style="font-family: ${font}">${val}</span>` : val
        item.properties_formatted += `<div class="cart_drawer_property">${key}: ${val}</div>`
      }

    }
  })
  
  return cart
}

CartManager.addEngravingPriceToProduct = function(items) {
  function addPriceToItem(item) {
    item.price += CartManager.engravingPriceForItem(item.key, items)
    let cPrice = item.properties_all._compare_at_price
    if (cPrice && (cPrice+'').includes('|||')) { // fix - remove second part after 20.8.
      let compareAtPrice = parseInt(cPrice.split('|||')[0])
      let saving = cPrice.split('|||')[1]
      let newPrice = CartManager.engravingPriceForItem(item.key, items) + compareAtPrice
      item.properties_all._compare_at_price = newPrice + '|||' + saving
    }
  }
  let itemsNotEngraving = items.filter(item => !CartManager.isEngravingId(item.id))

  itemsNotEngraving.forEach(item => addPriceToItem(item))
  return items
}

// Returns price of engraving that is attached to the parent item
CartManager.engravingPriceForItem = function(parentKey, items) {
  let sum = 0
  items.forEach(item => {
    if (item.properties_all?._parent_key == parentKey) sum += item.price
  })
  return sum
}

CartManager.isEngravingId = function(id) {
  return ENGRAVING_PRODUCT_IDS.includes(id)
}

CartManager.isItemEngraving = function(item) {
  return ENGRAVING_PRODUCT_IDS.includes(item.variant_id)
}

// Cart update (on qty change)
// If item has engaving attached to it, then the engraving is added to updateObj - updateObj is sent to shopify via ajax
CartManager.addChildEngraving = function(parentKey, updateObj, qty) {
  for (let item of CartManager.lastCart.items) {
    if (CartManager.isItemEngraving(item) && item.properties_all?._parent_key == parentKey)
        updateObj[item.key] = qty    // Set new quantity for engraving
  }

  return updateObj
}

CartManager.removeOrphansFromCart = function() {
  let orphanList = CartManager.getEngravingOrphans()
  let data = {updates: {}}
  orphanList.forEach(orphan => data.updates[orphan.key] = 0)

  return $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(cart) {
      $('body').trigger('removed.orphans')
    },
    error: function(XMLHttpRequest, textStatus) {}
  })
}

CartManager.getEngravingOrphans = function() {
  let engravingList = CartManager.lastCart.items.filter(item => CartManager.isItemEngraving(item))
  let orphanList = engravingList.filter(engraving => !CartManager.engravingHasParent(engraving))
  return orphanList  
}

CartManager.engravingHasParent = function(engraving) {
  let parents = CartManager.lastCart.items.filter(item => item.key == engraving.properties_all?._parent_key)
  return parents.length > 0
}

CartManager.addEngravingOrphans = function(updateObj) {
  let orphanList = CartManager.getEngravingOrphans() 
  orphanList.forEach(orphan => updateObj[orphan.key] = 0)    // Set new quantity for engraving
  return updateObj
}

CartManager.getChildEngravings = function(parentKey) {
  let engravings = []
  for (let item of CartManager.lastCart.items)
    CartManager.isItemEngraving(item) && item.properties_all?._parent_key == parentKey && engravings.push(item)

  return engravings
}

Engravings.collectEngravingData = function($h) {
  let data = {}
  $h.find('select, input').filter('[name]').each(function() {
    data[$(this).attr('name')] = $(this).val()
  })
  return data
}

Engravings.insertCharacter = function(character, $userText, userTextLimit) {
  let userText = $userText.val();

  if (userText.length >= userTextLimit)
      return;

  let cursorPosition = $userText.getCursorPosition();
  let newText = [userText.slice(0, cursorPosition), character, userText.slice(cursorPosition)].join('');

  $userText.val(newText); 
  $userText.trigger('input');
  $userText.focus();
  $userText.setCursorPosition(cursorPosition + 1);
}

/*
___________________________

  @View
____________________________

*/


class EngravingView {
  
  constructor(config) {
    let this_ = this
    this.visible = false
    this.type = config.type
    this.tag = config.tag
    this.isValidated = false
    this.userTextLimit = this.type == LONG_BODY ? 170 : 30
    this.$h = config.$container.append(config.template).find('.engraving-view:last')
    this.$engravingContainer = this.$h.find('.preview div')
    this.$userText = this.$h.find('input.user-text')
    this.$userTextFormatted = this.$h.find('.user-text-formatted')
    this.$selectFont = this.$h.find('select.engraving-font')
    this.$resources = config.parent.$resources
    this.$counter = this.$h.find('b.counter')
    this.$emojis = this.$h.find('.emojis')
    this.$preview = this.$h.find('.preview')
    this.$img = this.$h.find('.preview img')
    this.$price = this.$h.find('.price')
    this.$enabled = this.$h.find('.enabled')
    this.setPreviewVars()
    this.initialPreviewClass = this.$preview.attr('class')
    let engravingProduct = this.getEngravingProductByHandle(this.type, this.tag)
    this.engravingProductId = engravingProduct.id
    this.engravingProductPrice = engravingProduct.price
   
    // Fill <select> with standard list of fonts
    if (this.$selectFont.find('option').length == 0)
      this.$selectFont.html(this.$resources.find('.engraving-font-options').html())

    // Hide "No engraving" option from $selectFont
    if (config.hideNoEngraving)
      this.$selectFont.find('option[value=""]').remove()

    // Add "No emojis" text to Poppins font option, because Weglot is disabled on these options.
    // let $poppins = this.$selectFont.find('[value="Poppins"]')
    // let txt = $poppins.html()
    // let translation = $('#engraving_option_no_emojis').html()
    // $poppins.html(txt.replace('{no-emojis}', translation))
    
    // On text change <input>
    this.$userText.on('input', function() {  this_.onUserTextChange()  }.bind(this))

    // On change font <select>
    this.$selectFont.change(function() {  this_.onFontChange()  }.bind(this))
   
    // Init
    this.initValidator()
    this.onFontChange() // refresh is called here
    this.displayPrice()
  }

  validate() {
    let errors = this.validatorTextField.validate()    
    this.isValidated = errors.every(error => !error.preventBuy);
    
    if (TEST) console.log('errors: ', errors)
    return errors
  }

  initValidator() {
    // Engraving is not added to cart if no text.
    // But no warnings are displayed.
  let error1 = new ValidatorError({
      handle: 'no-text',
      classesToAddOnError: '',
      classesToRemoveOnSuccess: '',
      preventPreview: false,
      preventBuy: true,
      isValid: userText => userText.length > 0
  })

    // Make sure words are not too long
    let error2 = new ValidatorError({
      $h: this.$h.find('.error-msg[data-index="1"]'),
      handle: 'not-enough-spaces',
      preventPreview: true,
      preventBuy: true,

      isValid: userText => {

        // Long engraving on body - must not have too many spaces
        if (LONG_BODY == this.type) return Engravings.formatText(userText, this) != null

        // Engraving on cap doesn't need spaces
        if (SHORT_CAP == this.type) return true

        // Short engraving on body also needs spaces
        if (SHORT_BODY == this.type) return Engravings.calculateTextTemplate(userText, 10) != null

      }
    })

    // Detect unsupported characters and emojis
    let $error3msg = this.$h.find('.error-msg[data-index="2"]')
    let error3 = new ValidatorError({
      handle: 'unsupported-characters',
      $h: $error3msg,
      hideMsgOnSuccess: false,
      classesToAddOnError: '',
      classesToRemoveOnSuccess: '',
      preventPreview: false,
      preventBuy: false,
      
      isValid: function(userText) {

        if (Engravings.removeUnsupportedEmojis(userText).unsupportedEmojis.length == 0) return true
         
        // If unsupported emojis were in text, display a warning for 3 sec
        else {
          setTimeout(function() { $error3msg.slideUp() }, 3000)
          return false
        }
      }
    })
    
  this.validatorTextField = new ValidatorField({
    $h: this.$h.find('input.user-text'),
    errors: [error3, error2, error1]
  })
  }
  
  displayPrice() {
    let text = $('#translation_price_for_engraving').text()
    //let price = theme.Currency.formatMoney(this.engravingProductPrice*100, theme.settings.moneyFormat)
    let price = "123€" //qweqwe
    this.$price.html(text + ' <b>' + price + '</b>')
  }
  
  show() {
    this.$h.show()
    this.visible = true
  }

  hide() {
    this.$h.hide()
    this.visible = false
  }

  collect() {
    let data = Engravings.collectEngravingData(this.$h)
    return this.$selectFont.val() == '' || !this.isValidated || data['properties[_engraving_text]'] == '' ? {} : data
  }

  onUserTextChange() {
    this.refresh()
  }

  fixEmojis(userText) {
    return FONTS_WITHOUT_EMOJIS.includes(this.selectedFontName) ? Engravings.clearEmojis(userText, this.$userText) : userText
  }

  renderEmojis() {
    this.$emojis.empty()
    if (FONTS_WITHOUT_EMOJIS.includes(this.selectedFontName)) return
    Engravings.addEmojisHtml(this.$emojis)
    this.$emojis.find('.engraving-character').click(event => Engravings.insertCharacter(event.target.innerText, this.$userText, this.userTextLimit))
  }

  refresh$userText() {
    let font = Engravings.findCurrentFontFamily(this.selectedFontName)
    let weight = Engravings.findCurrentFontWeight()
    let userText = this.fixEmojis(this.$userText.val())
    this.$userText.val(userText).css({'font-family': font, 'font-weight': weight})    
  }
  
  onFontChange() {
    this.selectedFontName = this.$selectFont.val()
    this.selectedFontName == '' ? this.$enabled.hide() : this.$enabled.show()
    this.renderEmojis()
    this.refresh$userText()
    this.refresh()
  }

  // This method returns an identifier that connects a product with a specific engraving.
  // Ident structure: tag + variant + index (think filename)
  // Examples: 'timeless-cap(navy)', 'cap(rose-gold-shine-finish)', 'glass-bottle_grey-cap', 'timeless-white(double-wall)(600)', 'cup-butter'
  getProductIdent() {
    function removeParenthesis(str) {
      return str.replace('(', '').replace(')', '')
    }

    let variant = g_getSelectedVariant()
    let ident = this.identTpl
    ident = ident.replace('{variant}', variant ? '(' + removeParenthesis(variant) + ')' : '')
    ident = ident.replace('{tag}', '_' + this.tag)
    ident = ident.replace('{dw}', g_product.tags.includes('double-wall') ? '(double-wall)' : '')
    ident = ident.replaceAll('__', '_').replaceAll(' ', '-').toLowerCase()
    if (ident.charAt(0) == '_') ident = ident.slice(1)
    return ident
  }

  // this.selector is a jQuery selector that finds engraving img in the resources html
  // this.handle is usually used for css and font properties
  
  setPreviewVars() {
    console.log('***error: original file')
    let { tag, type } = this

    //
    // Bundles
    //
    if (['engr1_timeless-latte_1000_dw_'].includes(tag)) {
      this.handle = 'timeless1000_dw'
      this.selector = `[data-engravingtype=${type}] .timeless1000_dw [data-tag=${tag}]`
      this.identTpl = 'bundle-timeless-latte_double-wall(1000)'
    }

    // 1 product, 2 engravings
    else if ('apreswim-bottle-beach-bag' == g_product.handle) {
      let selectedVariant = g_getSelectedVariant()
      if ("Après Swim" == selectedVariant) tag = this.tag = 'timeless-apreswim'
      if ("C'est la vie" == selectedVariant) tag = this.tag = 'timeless-cestlavie'
      let variant = this.handle = 'timeless600'
      this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .${variant} [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = '{tag}'
    }

    // 1 product, 2 engravings
    else if ('sandro-telling-stories-x-equa-water-bottle' == g_product.handle) {
      let selectedVariant = g_getSelectedVariant()
      if ("Off White" == selectedVariant) tag = this.tag = 'timeless-sandro-white'
      if ("Dark" == selectedVariant) tag = this.tag = 'timeless-sandro-dark'
      let variant = this.handle = 'timeless600'
      this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = '{tag}600'
    }
      
    else if ('hydration-bundle' == g_product.handle) {
      let variant = this.handle = 'timeless600'
      this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .${variant} [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = '{tag}{variant}'
    }

    //
    // Default products
    //
    else if (['engraving-cap-only'].includes(tag)) {
      this.handle = 'cap'
      this.selector = `[data-engravingtype=${type}] [data-cap="${g_getSelectedVariant()}"]`
      this.identTpl = (g_product.tags.includes('timeless-cap') ? 'timeless-' : '') + 'cap{variant}'
    }

    else if (g_product.type == 'EQUA Cup') {
      this.handle = 'cup'
      this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = '{tag}{variant}'
    }

    else if (g_product.type == 'Stainless Steel Bottles') {
      this.handle = 'stainless'
      this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .stainless [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`      
      this.identTpl = 'stainless_{tag}{variant}'
    }

    else if (g_product.type == 'Smart Water Bottles') {
      this.handle = 'smart'
      this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .smart [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = 'smart_{tag}{variant}'
    }

    else if (g_product.type == 'Timeless Water Bottle' || g_product.type == 'Timeless Water Bottle DW') {
      let dw = g_product.tags.includes('double-wall') ? '_dw' : ''
      let variant = 'timeless' + g_getSelectedVariant()
      this.handle = variant + dw
      this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .${variant + dw} [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = '{tag}'+(dw.replace('_dw', '{dw}'))+'{variant}'
    }

    else if (g_product.type == 'Glass Bottles') {
      this.handle = 'glass'
      this.selector = `[data-engravingtype=${type}] [data-tag="${tag}"]`
      this.identTpl = 'glass-bottle{tag}'
    }

    else {
      console.log('==== Alert ====: Product type not recognised')
    }
  }
  
  getEngravingProductByHandle() {
    let $closest = $(this.selector).closest('div[data-engravinghandle]')
    let handle = $closest.data('engravinghandle')
    let $input = $('#engraving-prices input[name="'+handle+'"]')
    return {
      id: $input.data('id'),
      price: parseInt($input.val()) / 100
    }
  }

  displayBackgroundImage() {
    let imgSrc = this.$resources.find(this.selector).attr('data-src')
    let toAdd = this.$resources.find(this.selector).attr('class')
    let classesToAdd = this.initialPreviewClass + (toAdd ? ' ' + toAdd : '')

    // Set image
    this.$img.attr('src', imgSrc)
    this.$preview.attr('class', classesToAdd)
  }

  getPreviewFunction() {

    let previews = {
      [SHORT_CAP]: Engravings.createCapEngravingPreview,
      [SHORT_BODY]: Engravings.createShortBodyEngravingPreview,
      [LONG_BODY]: Engravings.createLongBodyEngravingPreview
    }

    return previews[this.type]
  }
  
  refresh() {
    this.displayBackgroundImage()
    this.$engravingContainer.empty()
    let errors = this.validate()
    let userText = this.userText = this.$userText.val()

    // Respect the character limit
    if (userText.length > this.userTextLimit)
      userText = userText.substring(0, this.userTextLimit)

    // Remove unsupported emojis
    let cleanedText = Engravings.removeUnsupportedEmojis(userText)
    userText = cleanedText.newText

    // If font doesn't support emojis, remove them
    userText = this.userText = this.fixEmojis(userText)
    
    // Update input
    this.$userText.val(userText)

    // Refresh character counter
    this.$counter.html(userText.length + ' | ' + this.userTextLimit)
    
    // Display no preview if "preventPreview" is set
    if (errors.some(error => error.preventPreview)) return;
   
    // Display engraving text on background image
    // this.$engravingContainer.html(this.$userTextFormatted.val())

    // Build the preview according to this.type
    let buildPreview = this.getPreviewFunction()
    buildPreview(this)

  }

}


/*
___________________________

  @Personalise Button
___________________________

*/

class PersonaliseButton { 
  constructor() {
    this.$h = $('.personalise-button').addClass('active')
    this.state = 'closed'
    
    // <button> Personalise
    this.$h.click(() => {

      if ('closed' == this.state) {
        Engravings.AllEngravingForms.forEach(form => form.show())
        this.$h.addClass('drop')
        this.state = 'open'
      }

      else if ('open' == this.state) {
        Engravings.AllEngravingForms.forEach(form => form.hide())
        this.$h.removeClass('drop')
        this.state = 'closed'
      }
    })
  }
}

/*
___________________________

  @Form
___________________________

*/


class EngravingForm {
  
  constructor(config) {
    this.views = []
    this.visible = false
    this.$resources = $('#engraving-form-resources')
    this.$h = config.$container
    config.types = ENABLED_ENGRAVINGS[config.tag]
    let template = this.$resources.find('.engraving-header').closest('.template').html()
    this.$header = this.$h.prepend(template).find('.engraving-header')  // Header contains <select> to choose engraving type etc.
    this.$selectEngravingType = this.$header.find('select.engraving-type')
    this.hasHeader = config.types.size > 1;
    
    if (!this.hasHeader) {
      this.$header.hide()
      this.$selectEngravingType.val([...config.types][0])  // This set only has 1 element
    }

    // Show only registered types
    this.$selectEngravingType.find('option').each(function() {
      let val = $(this).attr('value')
      !config.types.has(val) && val !== '' && $(this).remove()
    })
    
    // Add all views to this form
    for (let type of config.types) {

      let viewConfig = {
        tag: config.tag,
        type: type,
        $container: this.$h,
        template: this.$resources.find('input.engraving-type[value="'+type+'"]').closest('.template').html(),
        parent: this,
        hideNoEngraving: config.types.size > 1
      }

      this.views.push(new EngravingView(viewConfig))
    }
    
    // <select> Engraving type
    this.$selectEngravingType.on('change', () => {
      this.hideAllViews()
      this.showViewByType(this.$selectEngravingType.val())
    })

    // Show the first view
    this.$selectEngravingType.trigger('change')
  }

  show() {
    this.$h.slideDown()
    this.visible = true
  }

  hide() {
    this.$h.slideUp()
    this.visible = false
  }

  showFast() {
    this.$h.show()
    this.visible = true
  }

  hideFast() {
    this.$h.hide()
    this.visible = false
  }  
  
  hideAllViews() {
    this.views.forEach(view => view.hide())
  }

  showViewByType(type) {
    this.getViewByType(type)?.show()
  }

  getViewByType(type) {
    return this.views.find(view => view.type === type);
  }

  getVisibleView() {
    return this.views.find(view => view.visible)
  }

  refresh() {
    this.getVisibleView()?.setPreviewVars()
    this.getVisibleView()?.refresh()
  }
   
  collect() {   // Form
    let view = this.getVisibleView()
    return view && this.$selectEngravingType.val() !== '' ? view.collect() : {}
  }

  engravingPropertiesForParentProduct() {   // Form

    let viewData = this.collect()  // Collect data from visible view

    if ($.isEmptyObject(viewData))  // If no engraving is selected
      return viewData

    let properties = {}
    for (let key in viewData) {
      let prop = key.replace('properties[', '').replace(']', '')
      properties[prop] = viewData[key]
    }

    let readableTitle = $('#translation_engraving_text').text()
    properties[readableTitle] = properties['_engraving_text']

    return properties
  }

  dataForAjaxCartAdd(product) {   // Form

    let viewData = this.collect()  // Collect data from visible view

    if ($.isEmptyObject(viewData)) return viewData  // If no engraving is selected
   
    let properties = {
      '_parent_key': product.key,
      '_engraving_backup': product.properties._engraving_data,
      [$('#translation_engraving_for').html()]: product.title
    }
    
    return { quantity: 1, id: this.getVisibleView().engravingProductId, properties: properties }
  }
}

/*
____________________________
 
  @ONLOAD - INIT ENGRAVINGS
____________________________
 
*/

$(document).ready(function() {
// Register all available engravings.
// This is needed on all pages. This should actually be in some other file.
// It's not clear when to use CartManager and when Engravings. //fix
Engravings.registerEngravings()
Engravings.collectAllEngravingProductIds()

// Exit if we are not on the product page
if (!g_product) return

// Add a second engraving
// g_product.tags.push('engr1_timeless-latte_1000_dw_')

// Build the engravings forms
Engravings.productTags().forEach((tag, i) => {
  let configForm = {
    $container: $('.engraving-form:eq('+i+')'),
    tag: tag
  }
  Engravings.AllEngravingForms.push(new EngravingForm(configForm))
})

// Init Personalise button
if (Engravings.AllEngravingForms.length) Engravings.personaliseButton = new PersonaliseButton()

Engravings.refreshAll()
})